import React from 'react';
import { ControlUnitAPIResponse } from '../../../redux/controlUnit/api/ControlUnit.model';
import { useCurrentStateByDeckOvenId } from '../../../redux/composableDevice/hooks/useCurrentStateByControlUnitId';
import {
  Box,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import DeckActionsStatus from './DeckActionsStatus';
import DeckSensors from './DeckSensors';
import { useNavigate } from 'react-router-dom';
import useCommanderStatus from '../../../redux/commander/commander-status/hooks/useCommanderStatus';

export interface DeckControlUnitOvenProps {
  controlUnit: ControlUnitAPIResponse;
  deviceName?: string;
  deviceId: string;
}
function DeckControlUnitOven(props: DeckControlUnitOvenProps) {
  const { controlUnit, deviceId, deviceName } = props;

  const {
    deckOvenData: {
      analog: {
        topHeat,
        bottomHeat,
        top2Heat,
        steamboiler,
        setpointTopTemperature,
        setpointBottomTemperature,
        setpointSteamTemperature,
      },
      actions: { on, light, clapet, burner, multiFunction, fan },
    },
    currentStateControlUnit: { CUTranslate },
  } = useCurrentStateByDeckOvenId(deviceId, controlUnit?.id);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const { commanderStatus } = useCommanderStatus(deviceId);
  const isDeviceConnected = commanderStatus?.mqttConnected;

  return (
    <Box
      sx={{
        padding: '0 1rem',
      }}
    >
      <Box
        display={'grid'}
        gridTemplateColumns={isMobile ? '1fr' : '1fr 4fr'}
        justifyContent={'space-between'}
        gap={'0.5rem'}
      >
        <Box
          display={'flex'}
          flexDirection={isMobile ? 'row' : 'column'}
          alignItems={'center'}
          justifyContent={isMobile ? 'space-between' : 'space-evenly'}
          sx={{
            backgroundColor: isDeviceConnected
              ? theme.palette.background.paper
              : theme.palette.grey[200],
          }}
          width={'100%'}
          padding={1}
        >
          <Box padding={1} maxWidth={isMobile ? '45vw' : '100%'}>
            <Typography
              variant="h3"
              sx={{
                lineHeight: '1em',
                display: '-webkit-box',
                '-webkit-box-orient': 'vertical',
                overflow: 'hidden',
                '-webkit-line-clamp': '3',
                textOverflow: 'ellipsis',
                height: '3em',
                wordBreak: 'break-word',
              }}
            >
              {deviceName}
            </Typography>
          </Box>
          <DeckActionsStatus
            on={on}
            deviceId={deviceId}
            controlUnitId={controlUnit.id}
            CUTranslate={CUTranslate}
            isDeviceConnected={isDeviceConnected}
          />
        </Box>
        <Box
          width={isMobile ? '100%' : '88%'}
          sx={{
            backgroundColor:
              on?.value && isDeviceConnected
                ? theme.palette.background.paper
                : theme.palette.grey[200],
          }}
          padding={1}
        >
          <Box
            display={'flex'}
            flexDirection={'column'}
            justifyContent={'space-between'}
          >
            <div
              onClick={() =>
                navigate(`/devicemanager/device/${deviceId}/device-detail/`)
              }
            >
              <DeckSensors
                on={on?.value}
                topHeat={topHeat}
                top2Heat={top2Heat}
                bottomHeat={bottomHeat}
                steamboiler={steamboiler}
                setpointTopTemperature={setpointTopTemperature}
                setpointBottomTemperature={setpointBottomTemperature}
                setpointSteamTemperature={setpointSteamTemperature}
                CUTranslate={CUTranslate}
              />
              <Divider sx={{ borderWidth: 1 }} />{' '}
            </div>
            <Box
              sx={{
                padding: 1,
              }}
            >
              <DeckActionsStatus
                deviceId={deviceId}
                controlUnitId={controlUnit.id}
                light={light}
                clapet={clapet}
                burner={burner}
                multiFunction={multiFunction}
                fan={fan}
                CUTranslate={CUTranslate}
                isDeviceConnected={isDeviceConnected}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
export default DeckControlUnitOven;
